export const FormatsData: {[k: string]: ModdedSpeciesFormatsData} = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		randomBattleMoves: ["earthquake", "hiddenpowerice", "leafstorm", "leechseed", "powerwhip", "sleeppowder", "sludgebomb", "swordsdance", "synthesis"],
		tier: "UU",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		randomBattleMoves: ["airslash", "dragonpulse", "fireblast", "flamethrower", "hiddenpowergrass", "roost"],
		tier: "NU",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		randomBattleMoves: ["icebeam", "rapidspin", "rest", "roar", "sleeptalk", "surf", "toxic"],
		tier: "UU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		randomBattleMoves: ["bugbuzz", "safeguard", "sleeppowder", "stunspore", "uturn"],
		tier: "NU",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		randomBattleMoves: ["brickbreak", "poisonjab", "swordsdance", "toxicspikes", "uturn", "xscissor"],
		tier: "NU",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		randomBattleMoves: ["bravebird", "doubleedge", "pursuit", "quickattack", "uturn"],
		tier: "NU",
	},
	rattata: {
		tier: "LC",
	},
	raticate: {
		randomBattleMoves: ["crunch", "facade", "protect", "suckerpunch", "swordsdance", "uturn"],
		tier: "NU",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		randomBattleMoves: ["doubleedge", "drillpeck", "pursuit", "quickattack", "return", "uturn"],
		tier: "NU",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		randomBattleMoves: ["aquatail", "crunch", "earthquake", "glare", "gunkshot", "poisonjab", "seedbomb", "switcheroo"],
		tier: "NU",
	},
	pichu: {
		tier: "LC",
	},
	pichuspikyeared: {
		tier: "NU",
	},
	pikachu: {
		tier: "NU",
	},
	raichu: {
		randomBattleMoves: ["encore", "focusblast", "focuspunch", "grassknot", "hiddenpowerice", "nastyplot", "substitute", "thunderbolt"],
		tier: "NU",
	},
	sandshrew: {
		tier: "LC",
	},
	sandslash: {
		randomBattleMoves: ["earthquake", "nightslash", "rapidspin", "stealthrock", "stoneedge", "substitute", "swordsdance"],
		tier: "NU",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		randomBattleMoves: ["earthquake", "fireblast", "icebeam", "roar", "stealthrock", "toxicspikes"],
		tier: "NU",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		randomBattleMoves: ["earthquake", "fireblast", "icebeam", "megahorn", "stealthrock", "suckerpunch", "thunderbolt"],
		tier: "UU",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "NFE",
	},
	clefable: {
		randomBattleMoves: ["calmmind", "doubleedge", "fireblast", "icebeam", "softboiled", "stealthrock", "thunderbolt"],
		tier: "UU",
	},
	vulpix: {
		tier: "LC",
	},
	ninetales: {
		randomBattleMoves: ["energyball", "fireblast", "flamethrower", "hiddenpowerrock", "hypnosis", "nastyplot"],
		tier: "NU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		randomBattleMoves: ["bodyslam", "doubleedge", "fireblast", "healbell", "protect", "seismictoss", "stealthrock", "thunderwave", "toxic", "wish"],
		tier: "NU",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "NU",
	},
	crobat: {
		randomBattleMoves: ["bravebird", "heatwave", "nastyplot", "roost", "sludgebomb", "superfang", "taunt", "uturn"],
		tier: "UUBL",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		randomBattleMoves: ["energyball", "hiddenpowerfire", "moonlight", "sleeppowder", "sludgebomb", "solarbeam", "sunnyday"],
		tier: "NU",
	},
	bellossom: {
		randomBattleMoves: ["hiddenpowerfire", "leafstorm", "moonlight", "sleeppowder", "sludgebomb", "solarbeam", "sunnyday"],
		tier: "NU",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		randomBattleMoves: ["seedbomb", "spore", "stunspore", "synthesis", "xscissor"],
		tier: "NU",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		randomBattleMoves: ["bugbuzz", "psychic", "roost", "sleeppowder", "stunspore", "substitute", "toxicspikes", "uturn"],
		tier: "NU",
	},
	diglett: {
		tier: "NU",
	},
	dugtrio: {
		randomBattleMoves: ["earthquake", "nightslash", "stoneedge", "substitute", "suckerpunch"],
		tier: "UU",
	},
	meowth: {
		tier: "LC",
	},
	persian: {
		randomBattleMoves: ["bite", "fakeout", "hypnosis", "nastyplot", "return", "swift", "taunt", "uturn", "waterpulse"],
		tier: "NU",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		randomBattleMoves: ["calmmind", "encore", "hiddenpowergrass", "hydropump", "icebeam", "psychic", "surf"],
		tier: "NU",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		randomBattleMoves: ["closecombat", "encore", "icepunch", "punishment", "stoneedge", "uturn"],
		tier: "UU",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		randomBattleMoves: ["extremespeed", "flareblitz", "hiddenpowergrass", "morningsun", "thunderfang", "toxic", "willowisp"],
		tier: "UU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		randomBattleMoves: ["brickbreak", "bulkup", "encore", "focuspunch", "icepunch", "rest", "sleeptalk", "substitute", "toxic", "waterfall"],
		tier: "NU",
	},
	politoed: {
		randomBattleMoves: ["encore", "focusblast", "hiddenpowergrass", "hydropump", "icebeam", "protect", "surf", "toxic"],
		tier: "NU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "NU",
	},
	alakazam: {
		randomBattleMoves: ["encore", "focusblast", "hiddenpowerfire", "psychic", "shadowball", "signalbeam", "substitute", "trick"],
		tier: "UU",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "NU",
	},
	machamp: {
		randomBattleMoves: ["bulkup", "bulletpunch", "dynamicpunch", "icepunch", "payback", "stoneedge", "substitute"],
		tier: "OU",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		randomBattleMoves: ["leafblade", "leafstorm", "sleeppowder", "sludgebomb", "solarbeam", "suckerpunch", "sunnyday", "weatherball"],
		tier: "NU",
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		randomBattleMoves: ["hydropump", "icebeam", "rapidspin", "sludgebomb", "surf", "toxicspikes"],
		tier: "(OU)",
	},
	geodude: {
		tier: "LC",
	},
	graveler: {
		tier: "NFE",
	},
	golem: {
		randomBattleMoves: ["earthquake", "explosion", "hammerarm", "stealthrock", "stoneedge", "suckerpunch"],
		tier: "NU",
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		randomBattleMoves: ["flareblitz", "hypnosis", "megahorn", "morningsun", "willowisp"],
		tier: "NU",
	},
	slowpoke: {
		tier: "LC",
	},
	slowbro: {
		randomBattleMoves: ["calmmind", "psychic", "rest", "slackoff", "sleeptalk", "surf", "thunderwave", "toxic", "trickroom"],
		tier: "UU",
	},
	slowking: {
		randomBattleMoves: ["icebeam", "nastyplot", "psychic", "slackoff", "surf", "thunderwave", "toxic", "trickroom"],
		tier: "NU",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "NU",
	},
	magnezone: {
		randomBattleMoves: ["explosion", "flashcannon", "hiddenpowergrass", "hiddenpowerice", "magnetrise", "substitute", "thunderbolt"],
		tier: "OU",
	},
	farfetchd: {
		randomBattleMoves: ["leafblade", "nightslash", "return", "slash", "swordsdance", "uturn"],
		tier: "NU",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		randomBattleMoves: ["bravebird", "doubleedge", "pursuit", "quickattack", "return", "roost"],
		tier: "NU",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		randomBattleMoves: ["encore", "icebeam", "raindance", "rest", "surf", "toxic"],
		tier: "NU",
	},
	grimer: {
		tier: "LC",
	},
	muk: {
		randomBattleMoves: ["brickbreak", "curse", "explosion", "gunkshot", "icepunch", "payback", "poisonjab", "rest", "shadowsneak", "sleeptalk"],
		tier: "NU",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		randomBattleMoves: ["explosion", "iceshard", "rapidspin", "rockblast", "spikes", "surf", "toxicspikes"],
		tier: "UU",
	},
	gastly: {
		tier: "LC",
	},
	haunter: {
		tier: "NU",
	},
	gengar: {
		randomBattleMoves: ["focusblast", "hiddenpowerfire", "hypnosis", "painsplit", "shadowball", "sludgebomb", "substitute", "thunderbolt", "trick"],
		tier: "OU",
	},
	onix: {
		tier: "LC",
	},
	steelix: {
		randomBattleMoves: ["earthquake", "explosion", "gyroball", "roar", "stealthrock", "stoneedge", "toxic"],
		tier: "UU",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		randomBattleMoves: ["protect", "seismictoss", "thunderwave", "toxic", "wish"],
		tier: "NU",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		randomBattleMoves: ["agility", "crabhammer", "return", "superpower", "swordsdance", "xscissor"],
		tier: "NU",
	},
	voltorb: {
		tier: "LC",
	},
	electrode: {
		randomBattleMoves: ["explosion", "hiddenpowerice", "signalbeam", "taunt", "thunderbolt"],
		tier: "NU",
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		randomBattleMoves: ["explosion", "hiddenpowerfire", "leafstorm", "psychic", "sleeppowder", "solarbeam", "sunnyday", "synthesis"],
		tier: "UU",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		randomBattleMoves: ["doubleedge", "earthquake", "firepunch", "substitute", "swordsdance", "thunderpunch"],
		tier: "NU",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		randomBattleMoves: ["closecombat", "earthquake", "machpunch", "stoneedge", "substitute", "suckerpunch"],
		tier: "UU",
	},
	hitmonchan: {
		randomBattleMoves: ["bulkup", "closecombat", "drainpunch", "icepunch", "machpunch", "rapidspin", "stoneedge"],
		tier: "NU",
	},
	hitmontop: {
		randomBattleMoves: ["bulkup", "closecombat", "machpunch", "rapidspin", "stoneedge", "suckerpunch", "toxic"],
		tier: "UU",
	},
	lickitung: {
		tier: "LC",
	},
	lickilicky: {
		randomBattleMoves: ["aquatail", "bodyslam", "earthquake", "explosion", "healbell", "protect", "return", "wish"],
		tier: "NU",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		randomBattleMoves: ["fireblast", "painsplit", "rest", "sleeptalk", "sludgebomb", "thunderbolt", "willowisp"],
		tier: "UU",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		tier: "NFE",
	},
	rhyperior: {
		randomBattleMoves: ["earthquake", "icepunch", "megahorn", "rockpolish", "stealthrock", "stoneedge"],
		tier: "UU",
	},
	happiny: {
		tier: "LC",
	},
	chansey: {
		tier: "UU",
	},
	blissey: {
		randomBattleMoves: ["aromatherapy", "flamethrower", "icebeam", "protect", "seismictoss", "softboiled", "stealthrock", "thunderwave", "toxic", "wish"],
		tier: "OU",
	},
	tangela: {
		tier: "NU",
	},
	tangrowth: {
		randomBattleMoves: ["earthquake", "hiddenpowerfire", "hiddenpowerice", "leafstorm", "powerwhip", "rockslide", "sleeppowder", "stunspore", "swordsdance", "synthesis"],
		tier: "UU",
	},
	kangaskhan: {
		randomBattleMoves: ["doubleedge", "earthquake", "fakeout", "focuspunch", "hammerarm", "return", "substitute", "suckerpunch"],
		tier: "UU",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NFE",
	},
	kingdra: {
		randomBattleMoves: ["dracometeor", "dragondance", "hydropump", "icebeam", "outrage", "rest", "sleeptalk", "substitute", "waterfall"],
		tier: "OU",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		randomBattleMoves: ["icebeam", "megahorn", "raindance", "return", "waterfall"],
		tier: "NU",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		randomBattleMoves: ["hydropump", "icebeam", "psychic", "rapidspin", "recover", "surf", "thunderbolt"],
		tier: "OU",
	},
	mimejr: {
		tier: "LC",
	},
	mrmime: {
		randomBattleMoves: ["batonpass", "encore", "focusblast", "nastyplot", "psychic", "shadowball", "substitute", "taunt", "thunderbolt"],
		tier: "NU",
	},
	scyther: {
		randomBattleMoves: ["aerialace", "brickbreak", "bugbite", "pursuit", "quickattack", "roost", "swordsdance", "uturn"],
		tier: "UU",
	},
	scizor: {
		randomBattleMoves: ["bugbite", "bulletpunch", "pursuit", "roost", "superpower", "swordsdance", "uturn"],
		tier: "OU",
	},
	smoochum: {
		tier: "LC",
	},
	jynx: {
		randomBattleMoves: ["focusblast", "icebeam", "lovelykiss", "nastyplot", "psychic", "substitute"],
		tier: "NU",
	},
	elekid: {
		tier: "LC",
	},
	electabuzz: {
		tier: "NU",
	},
	electivire: {
		randomBattleMoves: ["crosschop", "earthquake", "flamethrower", "hiddenpowergrass", "icepunch", "thunderbolt"],
		tier: "(OU)",
	},
	magby: {
		tier: "LC",
	},
	magmar: {
		tier: "NFE",
	},
	magmortar: {
		randomBattleMoves: ["fireblast", "focusblast", "hiddenpowergrass", "hiddenpowerice", "substitute", "thunderbolt"],
		tier: "NU",
	},
	pinsir: {
		randomBattleMoves: ["closecombat", "earthquake", "quickattack", "stealthrock", "stoneedge", "swordsdance", "xscissor"],
		tier: "NU",
	},
	tauros: {
		randomBattleMoves: ["doubleedge", "earthquake", "payback", "pursuit", "return", "stoneedge"],
		tier: "NU",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		randomBattleMoves: ["bounce", "dragondance", "earthquake", "icefang", "rest", "sleeptalk", "stoneedge", "waterfall"],
		tier: "OU",
	},
	lapras: {
		randomBattleMoves: ["healbell", "hydropump", "icebeam", "surf", "thunderbolt", "toxic"],
		tier: "NU",
	},
	ditto: {
		randomBattleMoves: ["transform"],
		tier: "NU",
	},
	eevee: {
		tier: "LC",
	},
	vaporeon: {
		randomBattleMoves: ["icebeam", "protect", "roar", "surf", "toxic", "wish"],
		tier: "(OU)",
	},
	jolteon: {
		randomBattleMoves: ["batonpass", "hiddenpowergrass", "hiddenpowerice", "substitute", "thunderbolt", "yawn"],
		tier: "(OU)",
	},
	flareon: {
		randomBattleMoves: ["fireblast", "hiddenpowergrass", "lavaplume", "protect", "superpower", "toxic", "wish"],
		tier: "NU",
	},
	espeon: {
		randomBattleMoves: ["batonpass", "calmmind", "hiddenpowerground", "morningsun", "psychic", "shadowball", "substitute"],
		tier: "NUBL",
	},
	umbreon: {
		randomBattleMoves: ["curse", "healbell", "moonlight", "payback", "protect", "toxic", "wish"],
		tier: "(OU)",
	},
	leafeon: {
		randomBattleMoves: ["batonpass", "doubleedge", "healbell", "leafblade", "substitute", "swordsdance", "synthesis", "yawn"],
		tier: "UU",
	},
	glaceon: {
		randomBattleMoves: ["hiddenpowerfire", "hiddenpowerground", "icebeam", "protect", "shadowball", "toxic", "wish"],
		tier: "NU",
	},
	porygon: {
		tier: "LC",
	},
	porygon2: {
		randomBattleMoves: ["discharge", "icebeam", "recover", "toxic", "triattack"],
		tier: "NU",
	},
	porygonz: {
		randomBattleMoves: ["agility", "darkpulse", "hiddenpowerfighting", "icebeam", "nastyplot", "thunderbolt", "triattack", "trick"],
		tier: "UUBL",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		randomBattleMoves: ["earthpower", "hiddenpowergrass", "hydropump", "icebeam", "raindance", "spikes", "stealthrock", "surf"],
		tier: "UU",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		randomBattleMoves: ["aquajet", "rapidspin", "stealthrock", "stoneedge", "superpower", "swordsdance", "waterfall"],
		tier: "UU",
	},
	aerodactyl: {
		randomBattleMoves: ["earthquake", "rockslide", "roost", "stealthrock", "stoneedge", "taunt"],
		tier: "OU",
	},
	munchlax: {
		tier: "LC",
	},
	snorlax: {
		randomBattleMoves: ["bodyslam", "crunch", "curse", "earthquake", "firepunch", "pursuit", "rest", "return", "selfdestruct", "sleeptalk", "whirlwind"],
		tier: "(OU)",
	},
	articuno: {
		randomBattleMoves: ["healbell", "icebeam", "roar", "roost", "substitute", "toxic"],
		tier: "NU",
	},
	zapdos: {
		randomBattleMoves: ["heatwave", "hiddenpowergrass", "hiddenpowerice", "roost", "substitute", "thunderbolt", "toxic", "uturn"],
		tier: "OU",
	},
	moltres: {
		randomBattleMoves: ["airslash", "fireblast", "flamethrower", "hiddenpowergrass", "roost", "substitute", "toxic", "uturn"],
		tier: "UU",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NU",
	},
	dragonite: {
		randomBattleMoves: ["dracometeor", "dragonclaw", "dragondance", "earthquake", "extremespeed", "fireblast", "firepunch", "outrage", "roost", "superpower"],
		tier: "OU",
	},
	mewtwo: {
		randomBattleMoves: ["aurasphere", "calmmind", "fireblast", "icebeam", "psychic", "recover", "selfdestruct", "substitute", "taunt", "willowisp"],
		tier: "Uber",
	},
	mew: {
		randomBattleMoves: ["aurasphere", "explosion", "flamethrower", "nastyplot", "psychic", "softboiled", "stealthrock", "taunt", "uturn", "willowisp"],
		tier: "Uber",
	},
	chikorita: {
		tier: "LC",
	},
	bayleef: {
		tier: "NFE",
	},
	meganium: {
		randomBattleMoves: ["aromatherapy", "energyball", "leechseed", "lightscreen", "reflect", "synthesis", "toxic"],
		tier: "NU",
	},
	cyndaquil: {
		tier: "LC",
	},
	quilava: {
		tier: "NFE",
	},
	typhlosion: {
		randomBattleMoves: ["eruption", "fireblast", "focusblast", "hiddenpowergrass", "hiddenpowerrock"],
		tier: "NU",
	},
	totodile: {
		tier: "LC",
	},
	croconaw: {
		tier: "NFE",
	},
	feraligatr: {
		randomBattleMoves: ["aquajet", "dragondance", "earthquake", "icepunch", "lowkick", "return", "swordsdance", "waterfall"],
		tier: "UU",
	},
	sentret: {
		tier: "LC",
	},
	furret: {
		randomBattleMoves: ["aquatail", "brickbreak", "doubleedge", "firepunch", "return", "shadowclaw", "suckerpunch", "trick", "uturn"],
		tier: "NU",
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		randomBattleMoves: ["nightshade", "reflect", "roost", "toxic", "whirlwind"],
		tier: "NU",
	},
	ledyba: {
		tier: "LC",
	},
	ledian: {
		randomBattleMoves: ["encore", "lightscreen", "reflect", "roost", "toxic", "uturn"],
		tier: "NU",
	},
	spinarak: {
		tier: "LC",
	},
	ariados: {
		randomBattleMoves: ["bugbite", "poisonjab", "shadowsneak", "suckerpunch", "toxicspikes"],
		tier: "NU",
	},
	chinchou: {
		tier: "LC",
	},
	lanturn: {
		randomBattleMoves: ["confuseray", "discharge", "healbell", "icebeam", "surf", "thunderwave", "toxic"],
		tier: "UU",
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		tier: "NU",
	},
	togekiss: {
		randomBattleMoves: ["airslash", "aurasphere", "fireblast", "healbell", "nastyplot", "roost", "thunderwave"],
		tier: "(OU)",
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		randomBattleMoves: ["calmmind", "grassknot", "heatwave", "hiddenpowerfighting", "psychic", "roost", "trick", "uturn", "wish"],
		tier: "NU",
	},
	mareep: {
		tier: "LC",
	},
	flaaffy: {
		tier: "NFE",
	},
	ampharos: {
		randomBattleMoves: ["discharge", "focusblast", "hiddenpowerice", "signalbeam", "substitute", "thunderbolt"],
		tier: "NU",
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		randomBattleMoves: ["aquajet", "doubleedge", "icepunch", "return", "superpower", "waterfall"],
		tier: "UU",
	},
	bonsly: {
		tier: "LC",
	},
	sudowoodo: {
		randomBattleMoves: ["earthquake", "explosion", "stealthrock", "stoneedge", "suckerpunch", "toxic", "woodhammer"],
		tier: "NU",
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		randomBattleMoves: ["bounce", "encore", "grassknot", "leechseed", "sleeppowder", "stunspore", "substitute", "toxic", "uturn"],
		tier: "NU",
	},
	aipom: {
		tier: "LC",
	},
	ambipom: {
		randomBattleMoves: ["fakeout", "lowkick", "payback", "pursuit", "return", "uturn"],
		tier: "UU",
	},
	sunkern: {
		tier: "LC",
	},
	sunflora: {
		randomBattleMoves: ["earthpower", "hiddenpowerice", "leafstorm", "synthesis"],
		tier: "NU",
	},
	yanma: {
		tier: "NU",
	},
	yanmega: {
		randomBattleMoves: ["airslash", "bugbuzz", "hiddenpowerfire", "hiddenpowerground", "protect", "uturn"],
		tier: "UUBL",
	},
	wooper: {
		tier: "LC",
	},
	quagsire: {
		randomBattleMoves: ["earthquake", "encore", "icepunch", "recover", "toxic", "waterfall", "yawn"],
		tier: "NU",
	},
	murkrow: {
		tier: "NU",
	},
	honchkrow: {
		randomBattleMoves: ["bravebird", "heatwave", "pursuit", "suckerpunch", "superpower"],
		tier: "UUBL",
	},
	misdreavus: {
		tier: "NU",
	},
	mismagius: {
		randomBattleMoves: ["hiddenpowerfighting", "nastyplot", "painsplit", "shadowball", "substitute", "taunt", "thunderbolt", "willowisp"],
		tier: "UU",
	},
	unown: {
		randomBattleMoves: ["hiddenpowerpsychic"],
		tier: "NU",
	},
	wynaut: {
		tier: "Uber",
	},
	wobbuffet: {
		randomBattleMoves: ["counter", "destinybond", "encore", "mirrorcoat"],
		tier: "Uber",
	},
	girafarig: {
		randomBattleMoves: ["batonpass", "calmmind", "hiddenpowerfighting", "psychic", "thunderbolt"],
		tier: "NU",
	},
	pineco: {
		tier: "LC",
	},
	forretress: {
		randomBattleMoves: ["earthquake", "explosion", "gyroball", "rapidspin", "spikes", "stealthrock", "toxicspikes"],
		tier: "OU",
	},
	dunsparce: {
		randomBattleMoves: ["bite", "bodyslam", "headbutt", "rockslide", "roost", "thunderwave", "zenheadbutt"],
		tier: "NU",
	},
	gligar: {
		tier: "NU",
		doublesTier: "LC",
	},
	gliscor: {
		randomBattleMoves: ["earthquake", "roost", "stealthrock", "stoneedge", "swordsdance", "taunt", "toxic", "uturn"],
		tier: "OU",
	},
	snubbull: {
		tier: "LC",
	},
	granbull: {
		randomBattleMoves: ["bodyslam", "closecombat", "crunch", "earthquake", "firepunch", "healbell", "return", "thunderwave", "toxic"],
		tier: "NU",
	},
	qwilfish: {
		randomBattleMoves: ["destinybond", "explosion", "poisonjab", "spikes", "thunderwave", "toxicspikes", "waterfall"],
		tier: "UU",
	},
	shuckle: {
		randomBattleMoves: ["encore", "knockoff", "rest", "stealthrock", "toxic"],
		tier: "NU",
	},
	heracross: {
		randomBattleMoves: ["closecombat", "megahorn", "nightslash", "stoneedge", "substitute", "swordsdance"],
		tier: "UUBL",
	},
	sneasel: {
		tier: "NU",
	},
	weavile: {
		randomBattleMoves: ["icepunch", "iceshard", "lowkick", "nightslash", "pursuit", "swordsdance"],
		tier: "OU",
	},
	teddiursa: {
		tier: "LC",
	},
	ursaring: {
		randomBattleMoves: ["closecombat", "crunch", "earthquake", "facade", "protect", "swordsdance"],
		tier: "UU",
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		randomBattleMoves: ["fireblast", "hiddenpowerrock", "lavaplume", "recover", "stealthrock", "toxic", "willowisp"],
		tier: "NU",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		tier: "NU",
	},
	mamoswine: {
		randomBattleMoves: ["earthquake", "endeavor", "iceshard", "stealthrock", "stoneedge", "superpower"],
		tier: "(OU)",
	},
	corsola: {
		randomBattleMoves: ["recover", "reflect", "stealthrock", "surf", "toxic"],
		tier: "NU",
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		randomBattleMoves: ["energyball", "fireblast", "icebeam", "substitute", "surf"],
		tier: "NU",
	},
	delibird: {
		randomBattleMoves: ["aerialace", "brickbreak", "icepunch", "iceshard", "rapidspin", "seedbomb"],
		tier: "NU",
	},
	mantyke: {
		tier: "LC",
	},
	mantine: {
		randomBattleMoves: ["rest", "sleeptalk", "surf", "toxic"],
		tier: "NU",
	},
	skarmory: {
		randomBattleMoves: ["bravebird", "roost", "spikes", "stealthrock", "whirlwind"],
		tier: "OU",
	},
	houndour: {
		tier: "LC",
	},
	houndoom: {
		randomBattleMoves: ["darkpulse", "fireblast", "hiddenpowergrass", "nastyplot", "suckerpunch"],
		tier: "UU",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		randomBattleMoves: ["assurance", "earthquake", "iceshard", "rapidspin", "seedbomb", "stealthrock", "stoneedge"],
		tier: "UU",
	},
	stantler: {
		randomBattleMoves: ["earthquake", "energyball", "hypnosis", "megahorn", "return", "suckerpunch"],
		tier: "NU",
	},
	smeargle: {
		randomBattleMoves: ["counter", "spikes", "spore", "stealthrock", "uturn"],
		tier: "(OU)",
	},
	miltank: {
		randomBattleMoves: ["bodyslam", "curse", "earthquake", "healbell", "milkdrink", "stealthrock"],
		tier: "UU",
	},
	raikou: {
		randomBattleMoves: ["aurasphere", "calmmind", "hiddenpowerice", "shadowball", "thunderbolt"],
		tier: "UUBL",
	},
	entei: {
		randomBattleMoves: ["extremespeed", "flareblitz", "hiddenpowergrass", "ironhead", "stoneedge"],
		tier: "NUBL",
	},
	suicune: {
		randomBattleMoves: ["calmmind", "hiddenpowerelectric", "icebeam", "rest", "roar", "sleeptalk", "surf"],
		tier: "OU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NFE",
	},
	tyranitar: {
		randomBattleMoves: ["crunch", "dragondance", "earthquake", "fireblast", "firepunch", "icebeam", "icepunch", "pursuit", "stealthrock", "stoneedge", "superpower"],
		tier: "OU",
	},
	lugia: {
		randomBattleMoves: ["aeroblast", "calmmind", "earthpower", "icebeam", "roost", "substitute", "toxic", "whirlwind"],
		tier: "Uber",
	},
	hooh: {
		randomBattleMoves: ["bravebird", "earthquake", "punishment", "roost", "sacredfire", "substitute"],
		tier: "Uber",
	},
	celebi: {
		randomBattleMoves: ["earthpower", "energyball", "hiddenpowerfire", "leafstorm", "leechseed", "nastyplot", "psychic", "recover", "stealthrock", "substitute", "thunderwave", "uturn"],
		tier: "OU",
	},
	treecko: {
		tier: "LC",
	},
	grovyle: {
		tier: "NFE",
	},
	sceptile: {
		randomBattleMoves: ["earthquake", "energyball", "focusblast", "hiddenpowerfire", "hiddenpowerice", "leafstorm", "leechseed", "substitute"],
		tier: "UU",
	},
	torchic: {
		tier: "LC",
	},
	combusken: {
		tier: "NFE",
	},
	blaziken: {
		randomBattleMoves: ["agility", "fireblast", "flareblitz", "stoneedge", "superpower", "thunderpunch", "vacuumwave"],
		tier: "UU",
	},
	mudkip: {
		tier: "LC",
	},
	marshtomp: {
		tier: "NFE",
	},
	swampert: {
		randomBattleMoves: ["earthquake", "icebeam", "icepunch", "roar", "stealthrock", "stoneedge", "waterfall"],
		tier: "OU",
	},
	poochyena: {
		tier: "LC",
	},
	mightyena: {
		randomBattleMoves: ["firefang", "return", "suckerpunch", "superfang", "taunt", "toxic"],
		tier: "NU",
	},
	zigzagoon: {
		tier: "LC",
	},
	linoone: {
		randomBattleMoves: ["bellydrum", "extremespeed", "seedbomb", "shadowclaw"],
		tier: "NU",
	},
	wurmple: {
		tier: "LC",
	},
	silcoon: {
		tier: "NFE",
	},
	beautifly: {
		randomBattleMoves: ["bugbuzz", "hiddenpowerground", "psychic", "stunspore", "uturn"],
		tier: "NU",
	},
	cascoon: {
		tier: "NFE",
	},
	dustox: {
		randomBattleMoves: ["bugbuzz", "protect", "roost", "toxic", "whirlwind"],
		tier: "NU",
	},
	lotad: {
		tier: "LC",
	},
	lombre: {
		tier: "NFE",
	},
	ludicolo: {
		randomBattleMoves: ["energyball", "icebeam", "leechseed", "raindance", "substitute", "surf"],
		tier: "UU",
	},
	seedot: {
		tier: "LC",
	},
	nuzleaf: {
		tier: "NFE",
	},
	shiftry: {
		randomBattleMoves: ["darkpulse", "explosion", "hiddenpowerfire", "leafstorm", "lowkick", "seedbomb", "solarbeam", "suckerpunch", "sunnyday", "swordsdance"],
		tier: "NU",
	},
	taillow: {
		tier: "LC",
	},
	swellow: {
		randomBattleMoves: ["bravebird", "facade", "protect", "quickattack", "uturn"],
		tier: "UU",
	},
	wingull: {
		tier: "LC",
	},
	pelipper: {
		randomBattleMoves: ["airslash", "hiddenpowergrass", "hydropump", "roost", "surf", "toxic", "uturn"],
		tier: "NU",
	},
	ralts: {
		tier: "LC",
	},
	kirlia: {
		tier: "NFE",
	},
	gardevoir: {
		randomBattleMoves: ["calmmind", "focusblast", "psychic", "shadowball", "taunt", "thunderbolt", "willowisp"],
		tier: "NU",
	},
	gallade: {
		randomBattleMoves: ["closecombat", "icepunch", "nightslash", "psychocut", "shadowsneak", "stoneedge", "swordsdance", "trick"],
		tier: "UUBL",
	},
	surskit: {
		tier: "LC",
	},
	masquerain: {
		randomBattleMoves: ["agility", "airslash", "batonpass", "bugbuzz", "hydropump", "roost"],
		tier: "NU",
	},
	shroomish: {
		tier: "LC",
	},
	breloom: {
		randomBattleMoves: ["facade", "focuspunch", "leechseed", "machpunch", "seedbomb", "spore", "stoneedge", "substitute", "swordsdance"],
		tier: "OU",
	},
	slakoth: {
		tier: "LC",
	},
	vigoroth: {
		randomBattleMoves: ["bulkup", "earthquake", "encore", "focuspunch", "lowkick", "nightslash", "return", "slackoff", "substitute", "suckerpunch"],
		tier: "NU",
	},
	slaking: {
		randomBattleMoves: ["doubleedge", "earthquake", "firepunch", "icepunch", "nightslash", "pursuit", "return"],
		tier: "NU",
	},
	nincada: {
		tier: "LC",
	},
	ninjask: {
		randomBattleMoves: ["batonpass", "protect", "substitute", "swordsdance", "xscissor"],
		tier: "(OU)",
	},
	shedinja: {
		randomBattleMoves: ["shadowsneak", "suckerpunch", "swordsdance", "willowisp", "xscissor"],
		tier: "NU",
	},
	whismur: {
		tier: "LC",
	},
	loudred: {
		tier: "NFE",
	},
	exploud: {
		randomBattleMoves: ["crunch", "earthquake", "fireblast", "icebeam", "return", "surf"],
		tier: "NU",
	},
	makuhita: {
		tier: "LC",
	},
	hariyama: {
		randomBattleMoves: ["bulletpunch", "closecombat", "fakeout", "focuspunch", "icepunch", "payback", "stoneedge", "substitute"],
		tier: "UU",
	},
	nosepass: {
		tier: "LC",
	},
	probopass: {
		randomBattleMoves: ["earthpower", "powergem", "stealthrock", "thunderwave", "toxic"],
		tier: "NU",
	},
	skitty: {
		tier: "LC",
	},
	delcatty: {
		randomBattleMoves: ["doubleedge", "healbell", "return", "sing", "thunderwave", "wish"],
		tier: "NU",
	},
	sableye: {
		randomBattleMoves: ["nightshade", "recover", "seismictoss", "taunt", "toxic", "willowisp"],
		tier: "NU",
	},
	mawile: {
		randomBattleMoves: ["batonpass", "focuspunch", "ironhead", "substitute", "suckerpunch", "swordsdance"],
		tier: "NU",
	},
	aron: {
		tier: "LC",
	},
	lairon: {
		tier: "NFE",
	},
	aggron: {
		randomBattleMoves: ["aquatail", "earthquake", "headsmash", "icepunch", "lowkick", "rockpolish"],
		tier: "UU",
	},
	meditite: {
		tier: "NFE",
	},
	medicham: {
		randomBattleMoves: ["bulletpunch", "fakeout", "highjumpkick", "icepunch", "psychocut", "thunderpunch", "trick"],
		tier: "NU",
	},
	electrike: {
		tier: "LC",
	},
	manectric: {
		randomBattleMoves: ["flamethrower", "hiddenpowergrass", "overheat", "switcheroo", "thunderbolt"],
		tier: "NU",
	},
	plusle: {
		randomBattleMoves: ["batonpass", "encore", "hiddenpowerice", "nastyplot", "thunderbolt"],
		tier: "NU",
	},
	minun: {
		randomBattleMoves: ["batonpass", "encore", "hiddenpowerice", "nastyplot", "thunderbolt"],
		tier: "NU",
	},
	volbeat: {
		randomBattleMoves: ["batonpass", "bugbuzz", "encore", "substitute", "tailglow"],
		tier: "NU",
	},
	illumise: {
		randomBattleMoves: ["bugbuzz", "encore", "hiddenpowerground", "hiddenpowerice", "thunderbolt", "uturn"],
		tier: "NU",
	},
	budew: {
		tier: "LC",
	},
	roselia: {
		tier: "NU",
	},
	roserade: {
		randomBattleMoves: ["energyball", "hiddenpowerfire", "hiddenpowerice", "leafstorm", "rest", "sleeppowder", "sludgebomb", "spikes", "toxicspikes"],
		tier: "OU",
	},
	gulpin: {
		tier: "LC",
	},
	swalot: {
		randomBattleMoves: ["earthquake", "encore", "explosion", "icebeam", "sludgebomb", "toxic", "yawn"],
		tier: "NU",
	},
	carvanha: {
		tier: "LC",
	},
	sharpedo: {
		randomBattleMoves: ["aquajet", "crunch", "earthquake", "hiddenpowergrass", "hydropump", "icebeam", "waterfall"],
		tier: "NU",
	},
	wailmer: {
		tier: "LC",
	},
	wailord: {
		randomBattleMoves: ["hiddenpowergrass", "hydropump", "icebeam", "selfdestruct", "surf", "waterspout"],
		tier: "NU",
	},
	numel: {
		tier: "LC",
	},
	camerupt: {
		randomBattleMoves: ["earthpower", "earthquake", "explosion", "fireblast", "lavaplume", "rockpolish", "stealthrock", "stoneedge"],
		tier: "NU",
	},
	torkoal: {
		randomBattleMoves: ["earthquake", "explosion", "lavaplume", "rapidspin", "stealthrock", "toxic", "yawn"],
		tier: "NU",
	},
	spoink: {
		tier: "LC",
	},
	grumpig: {
		randomBattleMoves: ["calmmind", "focusblast", "healbell", "psychic", "shadowball", "thunderwave", "toxic"],
		tier: "NU",
	},
	spinda: {
		randomBattleMoves: ["bodyslam", "encore", "hypnosis", "seismictoss", "substitute", "teeterdance", "toxic"],
		tier: "NU",
	},
	trapinch: {
		tier: "LC",
	},
	vibrava: {
		tier: "NFE",
	},
	flygon: {
		randomBattleMoves: ["dragonclaw", "earthquake", "fireblast", "firepunch", "outrage", "roost", "stoneedge", "uturn"],
		tier: "OU",
	},
	cacnea: {
		tier: "LC",
	},
	cacturne: {
		randomBattleMoves: ["encore", "focuspunch", "lowkick", "seedbomb", "spikes", "substitute", "suckerpunch", "swordsdance"],
		tier: "NU",
	},
	swablu: {
		tier: "LC",
	},
	altaria: {
		randomBattleMoves: ["dragonclaw", "dragondance", "earthquake", "fireblast", "healbell", "outrage", "roost"],
		tier: "UU",
	},
	zangoose: {
		randomBattleMoves: ["closecombat", "quickattack", "return", "shadowclaw", "swordsdance"],
		tier: "NU",
	},
	seviper: {
		randomBattleMoves: ["aquatail", "darkpulse", "earthquake", "flamethrower", "sludgebomb", "suckerpunch", "switcheroo"],
		tier: "NU",
	},
	lunatone: {
		randomBattleMoves: ["batonpass", "calmmind", "earthpower", "psychic", "shadowball", "substitute"],
		tier: "NU",
	},
	solrock: {
		randomBattleMoves: ["earthquake", "explosion", "rockpolish", "stealthrock", "stoneedge", "zenheadbutt"],
		tier: "NU",
	},
	barboach: {
		tier: "LC",
	},
	whiscash: {
		randomBattleMoves: ["dragondance", "earthquake", "stoneedge", "waterfall"],
		tier: "NU",
	},
	corphish: {
		tier: "LC",
	},
	crawdaunt: {
		randomBattleMoves: ["crunch", "dragondance", "superpower", "waterfall", "xscissor"],
		tier: "NU",
	},
	baltoy: {
		tier: "LC",
	},
	claydol: {
		randomBattleMoves: ["earthquake", "explosion", "icebeam", "lightscreen", "rapidspin", "reflect", "stealthrock"],
		tier: "UU",
	},
	lileep: {
		tier: "LC",
	},
	cradily: {
		randomBattleMoves: ["curse", "earthquake", "recover", "rest", "rockslide", "seedbomb", "sleeptalk", "stealthrock", "toxic"],
		tier: "NU",
	},
	anorith: {
		tier: "LC",
	},
	armaldo: {
		randomBattleMoves: ["earthquake", "rapidspin", "rockpolish", "stealthrock", "stoneedge", "swordsdance", "toxic", "xscissor"],
		tier: "NU",
	},
	feebas: {
		tier: "LC",
	},
	milotic: {
		randomBattleMoves: ["haze", "icebeam", "recover", "rest", "sleeptalk", "surf", "toxic"],
		tier: "UU",
	},
	castform: {
		randomBattleMoves: ["energyball", "fireblast", "icebeam", "shadowball", "thunderbolt"],
		tier: "NU",
	},
	castformsunny: {},
	castformrainy: {},
	castformsnowy: {},
	kecleon: {
		randomBattleMoves: ["aquatail", "recover", "return", "stealthrock", "thunderwave", "toxic"],
		tier: "NU",
	},
	shuppet: {
		tier: "LC",
	},
	banette: {
		randomBattleMoves: ["destinybond", "hiddenpowerfighting", "shadowclaw", "shadowsneak", "taunt", "thunderwave", "willowisp"],
		tier: "NU",
	},
	duskull: {
		tier: "LC",
	},
	dusclops: {
		tier: "NU",
	},
	dusknoir: {
		randomBattleMoves: ["earthquake", "focuspunch", "icebeam", "painsplit", "shadowsneak", "substitute", "willowisp"],
		tier: "(OU)",
	},
	tropius: {
		randomBattleMoves: ["aerialace", "airslash", "earthquake", "energyball", "leafblade", "roost", "swordsdance", "toxic", "whirlwind"],
		tier: "NU",
	},
	chingling: {
		tier: "LC",
	},
	chimecho: {
		randomBattleMoves: ["calmmind", "hiddenpowerfire", "psychic", "recover", "signalbeam", "thunderwave", "yawn"],
		tier: "NU",
	},
	absol: {
		randomBattleMoves: ["nightslash", "psychocut", "pursuit", "suckerpunch", "superpower", "swordsdance"],
		tier: "UU",
	},
	snorunt: {
		tier: "LC",
	},
	glalie: {
		randomBattleMoves: ["earthquake", "explosion", "icebeam", "spikes", "taunt"],
		tier: "NU",
	},
	froslass: {
		randomBattleMoves: ["destinybond", "icebeam", "shadowball", "spikes", "taunt"],
		tier: "UUBL",
	},
	spheal: {
		tier: "LC",
	},
	sealeo: {
		tier: "NFE",
	},
	walrein: {
		randomBattleMoves: ["encore", "icebeam", "protect", "rest", "roar", "sleeptalk", "surf", "toxic"],
		tier: "NU",
	},
	clamperl: {
		tier: "NU",
	},
	huntail: {
		randomBattleMoves: ["doubleedge", "hiddenpowergrass", "hydropump", "icebeam", "raindance", "suckerpunch", "surf"],
		tier: "NU",
	},
	gorebyss: {
		randomBattleMoves: ["hiddenpowergrass", "hydropump", "icebeam", "raindance", "surf"],
		tier: "NU",
	},
	relicanth: {
		randomBattleMoves: ["aquatail", "doubleedge", "earthquake", "headsmash", "rockpolish", "stealthrock", "waterfall"],
		tier: "NU",
	},
	luvdisc: {
		randomBattleMoves: ["icebeam", "protect", "surf", "sweetkiss", "toxic"],
		tier: "NU",
	},
	bagon: {
		tier: "LC",
	},
	shelgon: {
		tier: "NU",
	},
	salamence: {
		randomBattleMoves: ["dracometeor", "dragondance", "earthquake", "fireblast", "outrage", "roost"],
		tier: "Uber",
	},
	beldum: {
		tier: "LC",
	},
	metang: {
		tier: "NU",
	},
	metagross: {
		randomBattleMoves: ["agility", "bulletpunch", "earthquake", "explosion", "meteormash", "stealthrock", "zenheadbutt"],
		tier: "OU",
	},
	regirock: {
		randomBattleMoves: ["earthquake", "explosion", "rest", "rockslide", "sleeptalk", "stealthrock", "thunderwave"],
		tier: "NU",
	},
	regice: {
		randomBattleMoves: ["focusblast", "icebeam", "rest", "sleeptalk", "thunderbolt", "thunderwave"],
		tier: "NU",
	},
	registeel: {
		randomBattleMoves: ["curse", "ironhead", "rest", "sleeptalk", "stealthrock", "thunderwave", "toxic"],
		tier: "UU",
	},
	latias: {
		randomBattleMoves: ["calmmind", "dragonpulse", "psychic", "refresh", "roost", "surf"],
		tier: "OU",
	},
	latios: {
		randomBattleMoves: ["calmmind", "dracometeor", "dragonpulse", "hiddenpowerfire", "psychic", "roost", "surf", "thunderbolt", "trick"],
		tier: "Uber",
	},
	kyogre: {
		randomBattleMoves: ["calmmind", "icebeam", "rest", "sleeptalk", "surf", "thunder", "waterspout"],
		tier: "Uber",
	},
	groudon: {
		randomBattleMoves: ["earthquake", "firepunch", "rockpolish", "stealthrock", "stoneedge", "swordsdance", "toxic"],
		tier: "Uber",
	},
	rayquaza: {
		randomBattleMoves: ["dragonclaw", "dragondance", "earthquake", "extremespeed", "outrage", "overheat", "swordsdance"],
		tier: "Uber",
	},
	jirachi: {
		randomBattleMoves: ["bodyslam", "calmmind", "firepunch", "flashcannon", "icepunch", "ironhead", "psychic", "stealthrock", "substitute", "thunderbolt", "uturn", "wish"],
		tier: "OU",
	},
	deoxys: {
		randomBattleMoves: ["extremespeed", "icebeam", "psychoboost", "spikes", "stealthrock", "superpower"],
		tier: "Uber",
	},
	deoxysattack: {
		randomBattleMoves: ["extremespeed", "hiddenpowerfire", "icebeam", "psychoboost", "shadowball", "stealthrock", "superpower"],
		tier: "Uber",
	},
	deoxysdefense: {
		randomBattleMoves: ["recover", "seismictoss", "spikes", "stealthrock", "taunt", "toxic"],
		tier: "Uber",
	},
	deoxysspeed: {
		randomBattleMoves: ["lightscreen", "psychoboost", "reflect", "spikes", "stealthrock", "superpower", "taunt"],
		tier: "Uber",
	},
	turtwig: {
		tier: "LC",
	},
	grotle: {
		tier: "NFE",
	},
	torterra: {
		randomBattleMoves: ["earthquake", "leechseed", "roar", "rockpolish", "stealthrock", "stoneedge", "synthesis", "woodhammer"],
		tier: "UU",
	},
	chimchar: {
		tier: "LC",
	},
	monferno: {
		tier: "NU",
	},
	infernape: {
		randomBattleMoves: ["closecombat", "flareblitz", "grassknot", "hiddenpowerice", "machpunch", "stealthrock", "stoneedge", "swordsdance", "uturn"],
		tier: "OU",
	},
	piplup: {
		tier: "LC",
	},
	prinplup: {
		tier: "NFE",
	},
	empoleon: {
		randomBattleMoves: ["agility", "grassknot", "hiddenpowerelectric", "hydropump", "icebeam", "roar", "stealthrock", "surf"],
		tier: "OU",
	},
	starly: {
		tier: "LC",
	},
	staravia: {
		tier: "NFE",
	},
	staraptor: {
		randomBattleMoves: ["bravebird", "closecombat", "doubleedge", "pursuit", "quickattack", "return", "roost", "substitute", "uturn"],
		tier: "UUBL",
	},
	bidoof: {
		tier: "LC",
	},
	bibarel: {
		randomBattleMoves: ["curse", "quickattack", "rest", "waterfall"],
		tier: "NU",
	},
	kricketot: {
		tier: "LC",
	},
	kricketune: {
		randomBattleMoves: ["brickbreak", "nightslash", "return", "swordsdance", "xscissor"],
		tier: "NU",
	},
	shinx: {
		tier: "LC",
	},
	luxio: {
		tier: "NFE",
	},
	luxray: {
		randomBattleMoves: ["crunch", "icefang", "protect", "roar", "superpower", "thunderbolt", "toxic"],
		tier: "NU",
	},
	cranidos: {
		tier: "LC",
	},
	rampardos: {
		randomBattleMoves: ["earthquake", "firepunch", "icebeam", "rockpolish", "stoneedge", "zenheadbutt"],
		tier: "NU",
	},
	shieldon: {
		tier: "LC",
	},
	bastiodon: {
		randomBattleMoves: ["earthquake", "metalburst", "protect", "roar", "rockslide", "stealthrock", "toxic"],
		tier: "NU",
	},
	burmy: {
		tier: "LC",
	},
	wormadam: {
		randomBattleMoves: ["hiddenpowerice", "hiddenpowerrock", "leafstorm", "psychic", "signalbeam"],
		tier: "NU",
	},
	wormadamsandy: {
		randomBattleMoves: ["earthquake", "rest", "sleeptalk", "toxic"],
		tier: "NU",
	},
	wormadamtrash: {
		randomBattleMoves: ["gyroball", "protect", "stealthrock", "toxic"],
		tier: "NU",
	},
	mothim: {
		randomBattleMoves: ["airslash", "bugbuzz", "hiddenpowerground", "roost", "shadowball", "uturn"],
		tier: "NU",
	},
	combee: {
		tier: "LC",
	},
	vespiquen: {
		randomBattleMoves: ["attackorder", "defendorder", "protect", "roost", "substitute", "toxic"],
		tier: "NU",
	},
	pachirisu: {
		randomBattleMoves: ["discharge", "lightscreen", "superfang", "toxic", "uturn"],
		tier: "NU",
	},
	buizel: {
		tier: "LC",
	},
	floatzel: {
		randomBattleMoves: ["aquajet", "batonpass", "bulkup", "crunch", "icepunch", "return", "taunt", "waterfall"],
		tier: "NU",
	},
	cherubi: {
		tier: "LC",
	},
	cherrim: {
		randomBattleMoves: ["aromatherapy", "energyball", "grasswhistle", "hiddenpowerfire", "hiddenpowerground", "synthesis"],
		tier: "NU",
	},
	cherrimsunshine: {
		randomBattleMoves: ["hiddenpowerice", "solarbeam", "sunnyday", "weatherball"],
	},
	shellos: {
		tier: "LC",
	},
	gastrodon: {
		randomBattleMoves: ["earthpower", "icebeam", "recover", "surf", "toxic"],
		tier: "NU",
	},
	drifloon: {
		tier: "LC",
	},
	drifblim: {
		randomBattleMoves: ["calmmind", "hiddenpowerfighting", "rest", "shadowball", "substitute", "thunderbolt"],
		tier: "NU",
	},
	buneary: {
		tier: "LC",
	},
	lopunny: {
		randomBattleMoves: ["batonpass", "encore", "healingwish", "return", "substitute", "thunderwave", "toxic"],
		tier: "NU",
	},
	glameow: {
		tier: "LC",
	},
	purugly: {
		randomBattleMoves: ["fakeout", "return", "shadowclaw", "suckerpunch", "taunt", "uturn"],
		tier: "NU",
	},
	stunky: {
		tier: "LC",
	},
	skuntank: {
		randomBattleMoves: ["crunch", "explosion", "fireblast", "poisonjab", "pursuit", "suckerpunch", "taunt"],
		tier: "NU",
	},
	bronzor: {
		tier: "LC",
	},
	bronzong: {
		randomBattleMoves: ["earthquake", "explosion", "gyroball", "hypnosis", "lightscreen", "payback", "reflect", "stealthrock"],
		tier: "OU",
	},
	chatot: {
		randomBattleMoves: ["encore", "heatwave", "hiddenpowergrass", "hypervoice", "nastyplot", "uturn"],
		tier: "NU",
	},
	spiritomb: {
		randomBattleMoves: ["calmmind", "darkpulse", "hiddenpowerfighting", "rest", "sleeptalk", "willowisp"],
		tier: "UU",
	},
	gible: {
		tier: "LC",
	},
	gabite: {
		tier: "NU",
	},
	garchomp: {
		randomBattleMoves: ["dragonclaw", "earthquake", "fireblast", "outrage", "stealthrock", "stoneedge", "substitute", "swordsdance"],
		tier: "Uber",
	},
	riolu: {
		tier: "LC",
	},
	lucario: {
		randomBattleMoves: ["agility", "closecombat", "crunch", "extremespeed", "icepunch", "stoneedge", "swordsdance"],
		tier: "OU",
	},
	hippopotas: {
		tier: "NUBL",
	},
	hippowdon: {
		randomBattleMoves: ["earthquake", "icefang", "roar", "slackoff", "stealthrock", "stoneedge", "toxic"],
		tier: "OU",
	},
	skorupi: {
		tier: "LC",
	},
	drapion: {
		randomBattleMoves: ["aquatail", "crunch", "earthquake", "icefang", "pursuit", "swordsdance", "taunt", "toxicspikes", "whirlwind"],
		tier: "UU",
	},
	croagunk: {
		tier: "LC",
	},
	toxicroak: {
		randomBattleMoves: ["crosschop", "focuspunch", "icepunch", "substitute", "suckerpunch", "swordsdance"],
		tier: "UU",
	},
	carnivine: {
		randomBattleMoves: ["powerwhip", "return", "sleeppowder", "substitute", "swordsdance", "synthesis"],
		tier: "NU",
	},
	finneon: {
		tier: "LC",
	},
	lumineon: {
		randomBattleMoves: ["hiddenpowerelectric", "hiddenpowergrass", "icebeam", "raindance", "surf", "uturn"],
		tier: "NU",
	},
	snover: {
		tier: "NUBL",
	},
	abomasnow: {
		randomBattleMoves: ["blizzard", "earthquake", "energyball", "hiddenpowerfire", "iceshard", "leechseed", "substitute", "woodhammer"],
		tier: "UUBL",
	},
	rotom: {
		randomBattleMoves: ["hiddenpowerfighting", "hiddenpowerice", "painsplit", "shadowball", "substitute", "thunderbolt", "trick", "willowisp"],
		tier: "UU",
	},
	rotomheat: {
		randomBattleMoves: ["hiddenpowerice", "overheat", "shadowball", "thunderbolt", "trick", "willowisp"],
		tier: "OU",
	},
	rotomwash: {
		randomBattleMoves: ["hiddenpowerice", "hydropump", "painsplit", "rest", "shadowball", "sleeptalk", "substitute", "thunderbolt", "trick", "willowisp"],
		tier: "OU",
	},
	rotomfrost: {
		randomBattleMoves: ["blizzard", "painsplit", "rest", "shadowball", "sleeptalk", "substitute", "thunderbolt", "trick", "willowisp"],
		tier: "OU",
	},
	rotomfan: {
		randomBattleMoves: ["airslash", "discharge", "hiddenpowerice", "painsplit", "rest", "shadowball", "sleeptalk", "substitute", "willowisp"],
		tier: "OU",
	},
	rotommow: {
		randomBattleMoves: ["hiddenpowerice", "leafstorm", "shadowball", "thunderbolt", "trick", "willowisp"],
		tier: "OU",
	},
	uxie: {
		randomBattleMoves: ["lightscreen", "psychic", "reflect", "stealthrock", "thunderwave", "uturn", "yawn"],
		tier: "UU",
	},
	mesprit: {
		randomBattleMoves: ["calmmind", "hiddenpowerfire", "icebeam", "psychic", "stealthrock", "substitute", "thunderbolt", "thunderwave", "uturn"],
		tier: "UU",
	},
	azelf: {
		randomBattleMoves: ["explosion", "fireblast", "flamethrower", "hiddenpowerfighting", "nastyplot", "psychic", "stealthrock", "thunderbolt", "uturn"],
		tier: "OU",
	},
	dialga: {
		randomBattleMoves: ["aurasphere", "bulkup", "dracometeor", "dragonclaw", "earthquake", "fireblast", "outrage", "rest", "sleeptalk", "stealthrock", "thunderbolt", "toxic"],
		tier: "Uber",
	},
	palkia: {
		randomBattleMoves: ["aurasphere", "dracometeor", "fireblast", "hydropump", "spacialrend", "surf", "thunderbolt"],
		tier: "Uber",
	},
	heatran: {
		randomBattleMoves: ["dragonpulse", "earthpower", "explosion", "fireblast", "hiddenpowergrass", "lavaplume", "protect", "roar", "stealthrock", "substitute"],
		tier: "OU",
	},
	regigigas: {
		randomBattleMoves: ["confuseray", "earthquake", "firepunch", "return", "substitute", "thunderwave", "toxic"],
		tier: "NU",
	},
	giratina: {
		randomBattleMoves: ["calmmind", "dragonpulse", "rest", "roar", "shadowball", "sleeptalk", "willowisp"],
		tier: "Uber",
	},
	giratinaorigin: {
		randomBattleMoves: ["aurasphere", "calmmind", "dracometeor", "dragonpulse", "hiddenpowerfire", "outrage", "shadowball", "shadowsneak", "substitute"],
	},
	cresselia: {
		randomBattleMoves: ["calmmind", "hiddenpowerfire", "icebeam", "lightscreen", "moonlight", "psychic", "reflect", "substitute", "thunderwave", "toxic"],
		tier: "UUBL",
	},
	phione: {
		randomBattleMoves: ["icebeam", "raindance", "rest", "surf", "toxic"],
		tier: "NU",
	},
	manaphy: {
		randomBattleMoves: ["energyball", "icebeam", "surf", "tailglow"],
		tier: "Uber",
	},
	darkrai: {
		randomBattleMoves: ["darkpulse", "darkvoid", "focusblast", "nastyplot", "substitute"],
		tier: "Uber",
	},
	shaymin: {
		randomBattleMoves: ["earthpower", "hiddenpowerfire", "hiddenpowerice", "leechseed", "rest", "seedflare", "substitute"],
		tier: "(OU)",
	},
	shayminsky: {
		randomBattleMoves: ["airslash", "earthpower", "hiddenpowerfire", "hiddenpowerice", "leechseed", "seedflare", "substitute"],
		tier: "Uber",
	},
	arceus: {
		randomBattleMoves: ["earthquake", "extremespeed", "recover", "shadowclaw", "swordsdance"],
		tier: "AG",
	},
	arceusbug: {
		randomBattleMoves: ["calmmind", "earthpower", "icebeam", "judgment", "recover"],
	},
	arceusdark: {
		randomBattleMoves: ["calmmind", "focusblast", "judgment", "recover", "refresh"],
	},
	arceusdragon: {
		randomBattleMoves: ["calmmind", "flamethrower", "judgment", "recover", "refresh", "willowisp"],
	},
	arceuselectric: {
		randomBattleMoves: ["calmmind", "earthpower", "icebeam", "judgment", "recover"],
	},
	arceusfighting: {
		randomBattleMoves: ["calmmind", "darkpulse", "icebeam", "judgment", "recover"],
	},
	arceusfire: {
		randomBattleMoves: ["calmmind", "earthpower", "judgment", "recover", "thunderbolt"],
	},
	arceusflying: {
		randomBattleMoves: ["calmmind", "earthpower", "judgment", "recover", "refresh"],
	},
	arceusghost: {
		randomBattleMoves: ["calmmind", "focusblast", "judgment", "recover", "willowisp"],
	},
	arceusgrass: {
		randomBattleMoves: ["calmmind", "earthpower", "icebeam", "judgment", "recover", "thunderwave"],
	},
	arceusground: {
		randomBattleMoves: ["calmmind", "icebeam", "judgment", "recover", "thunderbolt"],
	},
	arceusice: {
		randomBattleMoves: ["calmmind", "earthpower", "flamethrower", "judgment", "recover", "thunderbolt"],
	},
	arceuspoison: {
		randomBattleMoves: ["calmmind", "earthpower", "judgment", "recover", "willowisp"],
	},
	arceuspsychic: {
		randomBattleMoves: ["calmmind", "focusblast", "judgment", "recover", "shadowball"],
	},
	arceusrock: {
		randomBattleMoves: ["calmmind", "earthpower", "judgment", "recover", "refresh", "willowisp"],
	},
	arceussteel: {
		randomBattleMoves: ["calmmind", "earthpower", "judgment", "recover", "willowisp"],
	},
	arceuswater: {
		randomBattleMoves: ["calmmind", "icebeam", "judgment", "recover", "refresh", "thunderbolt", "willowisp"],
	},
};
